import isArray from 'lodash/isArray';
import { FC, ReactNode } from 'react';
import { NamedEntityMinDto } from 'types/other';
import EntityLinkList from './EntityLinkList';
import LineClamp, { LineClampProps } from './LineClamp';

type SupervisedAndResponsibleEmployeesProps = {
    supervisedByEmployees: NamedEntityMinDto | NamedEntityMinDto[] | undefined;
    responsibleEmployees: NamedEntityMinDto | NamedEntityMinDto[] | undefined;
    /** Opens the employee links in a new browser tab. */
    newTab?: boolean;
    /** Shown after the supervising line, wrapping under it in a narrow cell. */
    supervisedSuffix?: ReactNode;
    /** Shown after the responsible line, wrapping under it in a narrow cell. */
    responsibleSuffix?: ReactNode;
} & Pick<LineClampProps, 'maxLineCount' | 'maxTooltipLineCount'>;

const withSuffix = (line: ReactNode, suffix: ReactNode): ReactNode =>
    line && suffix ? (
        <div className="flex flex-wrap items-center gap-x-1.5">
            {line}
            {suffix}
        </div>
    ) : (
        line
    );

const SupervisedAndResponsibleEmployees: FC<SupervisedAndResponsibleEmployeesProps> = ({
    supervisedByEmployees,
    responsibleEmployees,
    maxLineCount,
    maxTooltipLineCount,
    newTab,
    supervisedSuffix,
    responsibleSuffix,
}) => {
    const supervisedList = withSuffix(
        supervisedByEmployees ? (
            <EntityLinkList
                domain="employee"
                items={isArray(supervisedByEmployees) ? supervisedByEmployees : [supervisedByEmployees]}
                prefix="SP"
                newTab={newTab}
            />
        ) : null,
        supervisedSuffix
    );

    const responsibleList = withSuffix(
        responsibleEmployees ? (
            <EntityLinkList
                domain="employee"
                items={isArray(responsibleEmployees) ? responsibleEmployees : [responsibleEmployees]}
                prefix="RL"
                newTab={newTab}
            />
        ) : null,
        responsibleSuffix
    );

    return (
        <div className="flex flex-col">
            {maxLineCount !== undefined
                ? supervisedList && (
                      <LineClamp maxLineCount={maxLineCount} maxTooltipLineCount={maxTooltipLineCount}>
                          {supervisedList}
                      </LineClamp>
                  )
                : supervisedList}
            {maxLineCount !== undefined
                ? responsibleList && (
                      <LineClamp maxLineCount={maxLineCount} maxTooltipLineCount={maxTooltipLineCount}>
                          {responsibleList}
                      </LineClamp>
                  )
                : responsibleList}
        </div>
    );
};

export default SupervisedAndResponsibleEmployees;
